/**
 * 第三方路网 / 等高线数据源注册表
 * 目前无正式在线矢量 API，列表为空占位；接入后在此追加配置即可出现在工具箱三级菜单。
 *
 * 条目示例：
 * {
 *   id: 'example-contour',
 *   kind: 'contour', // 'road' | 'contour'
 *   name: '示例官方等高线',
 *   description: '说明与版权',
 *   bboxSupported: true,
 *   enabled: true
 * }
 */
export const THIRD_PARTY_MAP_SOURCES = [];

/** 按 kind 列出可用第三方源 */
export function listThirdPartySources(kind) {
  const k = String(kind || '').toLowerCase();
  return (THIRD_PARTY_MAP_SOURCES || []).filter(
    (s) => s && s.kind === k && s.enabled !== false
  );
}
